/* assets/section-product-image-carousel.js */
(() => {
  'use strict';

  const SECTION_SEL = '.product-image-carousel';
  const SWIPER_SEL = '.product-image-carousel__swiper';

  function destroySwiper(root) {
    if (root._picSwiper && typeof root._picSwiper.destroy === 'function') {
      root._picSwiper.destroy(true, true);
    }
    root._picSwiper = null;
    root.classList.remove('product-image-carousel--ready');
  }

  function recenter(swiper) {
    if (!swiper) return;
    swiper.update();
    if (swiper.params.loop) {
      swiper.slideToLoop(0, 0, false);
    } else {
      swiper.slideTo(0, 0, false);
    }
  }

  function initSwiper(root) {
    const container = root.querySelector(SWIPER_SEL);
    if (!container || typeof Swiper === 'undefined') {
      root.classList.add('product-image-carousel--ready');
      return null;
    }

    const slideCount = parseInt(root.dataset.slideCount || '0', 10);
    const prevEl = root.querySelector('[data-pic-prev]');
    const nextEl = root.querySelector('[data-pic-next]');
    const enableLoop = slideCount >= 4;

    const swiper = new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 14,
      centeredSlides: false,

      loop: enableLoop,
      loopAdditionalSlides: enableLoop ? 3 : 0,

      watchOverflow: true,
      grabCursor: true,

      speed: 750,

      navigation: prevEl && nextEl ? {
        prevEl,
        nextEl
      } : undefined,

      breakpoints: {
        750: {
          spaceBetween: 16,
        },
        990: {
          spaceBetween: 18,
        },
      },

      on: {
        init(instance) {
          requestAnimationFrame(() => {
            recenter(instance);
            root.classList.add('product-image-carousel--ready');
          });
        },

        resize(instance) {
          recenter(instance);
        },
      },
    });


    container.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', () => recenter(swiper), { once: true });
      }
    });

    setTimeout(() => recenter(swiper), 300);
    root._picSwiper = swiper;
    return swiper;
  }

  function init(root) {
    if (!root || root.dataset.picReady === 'true') return;
    root.dataset.picReady = 'true';
    destroySwiper(root);
    initSwiper(root);
  }

  function destroy(root) {
    if (!root) return;
    destroySwiper(root);
    delete root.dataset.picReady;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SECTION_SEL).forEach(init);
  }

  function destroyAll(scope) {
    (scope || document).querySelectorAll(SECTION_SEL).forEach(destroy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    destroyAll(event.target);
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyAll(event.target);
  });
})();
